import React from 'react';
import { TelemetryEmptySlot } from '../utils/telemetry-grid.utils';

export interface TelemetryEmptySlotProps {
  slot: TelemetryEmptySlot;
  onInsert: (slot: TelemetryEmptySlot) => void;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * TelemetryEmptySlotUI
 * Minimalist placeholder card rendered in vacant grid slots.
 * Hidden by default, smoothly appears on hover matching Atmos design aesthetics.
 */
export const TelemetryEmptySlotUI: React.FC<TelemetryEmptySlotProps> = ({
  slot,
  onInsert,
  className = '',
  style,
}) => {
  const isCompact = slot.h <= 2 || slot.w <= 2;
  const isUltraCompact = slot.w <= 1;

  return (
    <div
      key={slot.key}
      id={`telemetry-empty-slot-${slot.x}-${slot.y}`}
      className={`td-empty-slot ${isCompact ? 'td-empty-slot--compact' : ''} ${isUltraCompact ? 'td-empty-slot--ultra-compact' : ''} ${className}`}
      style={{
        left: slot.left,
        top: slot.top,
        width: slot.width,
        height: slot.height,
        ...style,
      }}
      onClick={() => onInsert(slot)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onInsert(slot);
        }
      }}
    >
      <div className="td-empty-slot-card">
        {/* Minimal Grid Icon Box */}
        <div className="td-empty-slot-icon">
          <svg width="22" height="22" viewBox="0 0 16 16" fill="none">
            <rect x="2" y="2" width="5" height="5" rx="1" stroke="var(--accent, #ccf54e)" strokeWidth="1.2" />
            <rect x="9" y="2" width="5" height="5" rx="1" stroke="var(--accent, #ccf54e)" strokeWidth="1.2" />
            <rect x="2" y="9" width="5" height="5" rx="1" stroke="var(--accent, #ccf54e)" strokeWidth="1.2" />
            <rect x="9" y="9" width="5" height="5" rx="1" stroke="var(--accent, #ccf54e)" strokeWidth="1.2" />
          </svg>
        </div>

        {!isCompact && (
          <span className="td-empty-slot-desc">
            Click to configure a telemetry panel{" "}
            <span className="block">in this space.</span>
          </span>
        )}
        <div className="td-empty-slot-btn">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M6 2v8M2 6h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
          <span>{isUltraCompact ? 'Add panel' : 'Add new panel'}</span>
        </div>
      </div>
    </div>
  );
};

export default TelemetryEmptySlotUI;
